import { render } from "./AccountEdit.vue?vue&type=template&id=0d53ea4a&ts=true"
import script from "./AccountEdit.vue?vue&type=script&lang=ts"
export * from "./AccountEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__